<template>
  <div class="cv-infos" :class="[{'isPlugin': isPlugin}]" v-if="cv.basic_info">
    <div class="school-logo-wrapper" v-if="cv.basic_info.school_logo_url && pageType === 'preview'">
      <img class="school-logo" :src="cv.basic_info.school_logo_url" alt="">
    </div>
    <div class="profile-wrapper">
      <div class="flex profile-container" :class="{'share-comment': shareCommentInfo.type === 'profile' && cv.basic_info.kind !== 'template' && cv.basic_info.kind !== 'sample'}" @click="toCvProfile">
        <div class="comment-total bubble-content bubble-comment-profile bubble-content-profile-total"
             v-if="getInfoCommentData('profile', 1).comment_count && pageType === 'share'">
          {{getInfoCommentData('profile', 1).comment_count}}
        </div>
        <button class="bubble-content flex-start bubble-comment-profile" v-else-if="shareCommentInfo.type === 'profile' && cv.basic_info.kind !== 'template' && cv.basic_info.kind !== 'sample'" @click.stop="addComment({ type: 'profile' }, profiles)">
          <i class="iconfont iconedit-"></i>
          <span>添加点评</span>
        </button>
        <div class="profile">
          <p class="name">
            <span>{{profiles.username | hideMessageFormat(hideProfile)}}</span>
          </p>
          <template v-if="profileShow">
            <div class="info">
              <span v-if="profiles.phone">{{profileLabel('电话', 'Phone')}}：{{ profiles.phone | hideMessageFormat(hideProfile) }}</span>
              <span v-if="profiles.email">{{profileLabel('邮箱', 'Email')}}：{{ profiles.email | hideMessageFormat(hideProfile) }}</span>
              <span v-if="profiles.address">{{profileLabel('现居城市', 'Address')}}：{{ profiles.address | hideMessageFormat(hideProfile) }}</span>
              <span v-if="profiles.wechat">{{profileLabel('微信', 'WeChat')}}：{{profiles.wechat | hideMessageFormat(hideProfile)}}</span>
              <span v-if="profiles.linked_in">{{profileLabel('领英', 'LinkedIn')}}：{{profiles.linked_in | hideMessageFormat(hideProfile)}}</span>
              <span v-if="profiles.homepage">{{profileLabel('个人网站', 'WebSite')}}：{{profiles.homepage | hideMessageFormat(hideProfile)}}</span>
              <span v-if="profiles.birthday && birthType === 'birthday'">
                {{profileLabel('生日', 'Birthdate')}}：{{profiles.birthday.slice(0, 7) | hideMessageFormat(hideProfile)}}</span>
              <span v-if="profiles.birthday && birthType === 'age'">
                {{profileLabel('年龄', 'Age')}}：{{ userAge | hideMessageFormat(hideProfile) }}
              </span>
              <span v-if="profiles.gender">{{profileLabel('性别', 'Gender')}}：{{profiles.gender | hideMessageFormat(hideProfile)}}</span>
              <span v-if="profiles.height">{{profileLabel('身高', 'Height')}}：{{profiles.height | hideMessageFormat(hideProfile)}}</span>
              <span v-if="profiles.weight">{{profileLabel('体重', 'Weight')}}：{{profiles.weight | hideMessageFormat(hideProfile)}}</span>
              <span v-if="profiles.hometown">{{profileLabel('籍贯', 'Hometown')}}：{{profiles.hometown | hideMessageFormat(hideProfile)}}</span>
              <span v-if="profiles.ethnic">{{profileLabel('民族', 'Ethnic')}}：{{profiles.ethnic | hideMessageFormat(hideProfile)}}</span>
              <span
                  v-if="profiles.political_status">{{profileLabel('政治面貌', 'Political Status')}}：{{profiles.political_status | hideMessageFormat(hideProfile)}}</span>
              <span
                  v-if="profiles.marriage">{{profileLabel('婚姻状况', 'Marriage Status')}}：{{profiles.marriage | hideMessageFormat(hideProfile)}}</span>
              <span
                  v-if="profiles.current_job">{{profileLabel('当前状态', 'Current Status')}}：{{profiles.current_job | hideMessageFormat(hideProfile)}}</span>
              <span v-if="profiles.exp_city">{{profileLabel('意向城市', 'Expected City')}}：{{profiles.exp_city | hideMessageFormat(hideProfile)}}</span>
              <span v-if="profiles.exp_job">{{profileLabel('期望职位', 'Objective')}}：{{profiles.exp_job | hideMessageFormat(hideProfile)}}</span>
              <span
                  v-if="profiles.expected_salary">{{profileLabel('期望薪资', 'Expected Salary')}}：{{profiles.expected_salary | hideMessageFormat(hideProfile)}}</span>
            </div>
          </template>
          <p class="no-profile" v-else>请填写您的基本信息～</p>
        </div>
        <div class="avatar" @click.stop="addAvatar" v-if="(profiles.avatar_url || pageType === 'editor') && !hideProfile">
          <img :src="profiles.avatar_url || 'https://files.wondercv.com/cvs/no-avatar.png'" alt="">
        </div>
      </div>
      <div class="school-logo-module flex-between" v-if="cv.basic_info.school_logo_url && pageType === 'editor'">
        <div class="logo-left flex-start">
          <span class="title">校徽</span>
        </div>
        <div class="logo-operation flex-start">
          <span class="iconfont iconbianji" @click="changeUpload('logo')"/>
          <span class="iconfont iconshanchujianli" @click="deleteConfirm('logo')"/>
        </div>
      </div>
    </div>
    <template v-for="(item, index) in moduleData">
      <div :key="index" class="module-wrapper" v-if="pageType === 'editor' || notEmpty(item.type, item.infos)">
        <div class="person-info" :id="item.type">
          <div class="title flex-between" @click="clearShareCommentInfo"
              :class="[{'other-section-title': item.type === 'extras'}]">
            <div class="header-left flex">
              <span class="module-title">{{item.title}}</span>
            </div>
            <span class="add" v-if="item.type !== 'skill_list' && item.type !== 'personal_summary' &&
                    item.type !== 'extras' && notEmpty(item.type, item.infos) && pageType === 'editor' && !(item.type ==='opus' && item.infos.length===5) "
                  @click.stop="addInfo(item)">添加</span>
            <span v-if="!notEmpty(item.type, item.infos) && pageType === 'editor'" class="iconfont iconchevron-right"/>
          </div>
          <div class="extras-container" :class="{'share-comment': shareCommentInfo.type === 'extras' && item.type === 'extras' && cv.basic_info.kind !== 'template' && cv.basic_info.kind !== 'sample'}">
            <div class="comment-total bubble-content bubble-comment-total"
                v-if="getInfoCommentData('extras', 1).comment_count && item.type === 'extras' && pageType === 'share' && !isPlugin">
              {{ getInfoCommentData('extras', 1).comment_count }}
            </div>
            <button class="bubble-content flex-start" v-else-if="shareCommentInfo.type === 'extras' && item.type === 'extras' && cv.basic_info.kind !== 'template' && cv.basic_info.kind !== 'sample'" @click.stop="addComment(item, val)">
              <i class="iconfont iconedit-"></i>
              <span>添加点评</span>
            </button>
            <template v-for="val in item.infos">
              <div class="list-item" :key="val.id" v-if="infoNotEmpty(val, item.type) && item.type !== 'extras'" :id="val.id"
                  :class="{ 'share-comment': shareCommentInfo.id === val.id && cv.basic_info.kind !== 'template' && cv.basic_info.kind !== 'sample', 'opus-item': item.type === 'opus' }"
                  @click="toInfoDetail(item, val.id, $event)" :style="{marginTop: val.is_sub_item ? '-13px' : '0px', border : val.is_sub_item ? '1px solid #F9F9F9' : 'none', paddingTop: val.is_sub_item ? '12px' : '0px'}">
                <div class="comment-total bubble-content bubble-comment-total" v-if="getInfoCommentData(item.type, val.id).comment_count && pageType === 'share' && !isPlugin">{{ getInfoCommentData(item.type, val.id).comment_count | countFilter }}</div>
                <button class="bubble-content flex-start" v-else-if="shareCommentInfo.id === val.id && cv.basic_info.kind !== 'template' && cv.basic_info.kind !== 'sample'" @click.stop="addComment(item, val)">
                  <i class="iconfont iconedit-"></i>
                  <span>添加点评</span>
                </button>
                <template v-if="item.type !== 'opus'">
                  <div class="flex-between item-title" v-if="(val.name || val.university || val.company) && !val.is_sub_item">
                    <span v-if="val.name">{{val.name}}</span>
                    <span v-if="val.university">{{val.university}}</span>
                    <span v-if="val.company">{{val.company}}</span>
                    <span v-if="pageType === 'editor'" class="iconfont iconchevron-right"/>
                  </div>
                  <div class="dept" v-if="val.city || val.major || val.degree || val.dept || val.uni_school || val.title">
                    <span v-if="val.city">{{ val.city }}</span>
                    <span v-if="val.major">{{ val.major }}</span>
                    <span v-if="val.degree">{{val.degree}}</span>
                    <span v-if="val.dept">{{ val.dept }}</span>
                    <span v-if="val.uni_school">{{val.uni_school}}</span>
                    <span v-if="val.title">{{ val.title }}</span>
                  </div>
                  <div class="desc" v-if="val.start_at || val.end_at || val.present">
                    <span v-if="val.start_at">{{val.start_at | timeFilter('YYYY.MM') }}</span>
                    <span v-if="val.start_at && (val.end_at || val.present)"> - </span>
                    <span v-if="val.end_at">{{val.end_at | timeFilter('YYYY.MM') }}</span>
                    <span v-if="val.present">{{val.present}}</span>
                  </div>
                  <div v-if="val.description" v-html="val.description" class="change-desc"></div>
                </template>
                <template v-else>
                  <div class="flex-between item-title" v-if="val.qrcode">
                    <span>{{val.title || `${cv.basic_info.lang === 'cn' ? '作品链接' : 'portfolio link'}`}}</span>
                    <span v-if="pageType === 'editor'" class="iconfont iconchevron-right"/>
                  </div>
                </template>
              </div>
              <li class="change-desc extras-list-item" :key="val.id" v-if="item.type === 'extras' && val.description"
                  @click="toInfoDetail(item)">
                <span class="extra-title">{{val.title}}</span>&nbsp;
                <span>{{val.description}}</span>
              </li>
            </template>
          </div>
          <div class="module-placeholder" @click.stop="defaultClick(item)"
              v-if="!notEmpty(item.type, item.infos) && pageType === 'editor'">
            {{ defaultText && defaultText[item.type] }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import {cvMixin} from '../../assets/js/mixin/cv'
  import {envMixin} from '../../assets/js/mixin/global'
  import {componentsMixin} from '../../assets/js/mixin/components'
  import editorPlaceHolder from '../../assets/json/editor-placeholder'
  import {mapMutations, mapState} from 'vuex'

  export default {
    name: 'mobile-cv',
    props: {
      pageType: {
        type: String,
        default: 'editor'
      },
      authorityData: {
        type: Object,
        default: () => {}
      },
      isPlugin:{ //是否是插件
        type: Boolean,
        default: false
      }
    },
    mixins: [cvMixin, envMixin, componentsMixin],
    data() {
      return {
        shareCommentInfo: {},
        profileCommentShow: true,
        hideProfile: false
      }
    },
    created () {
      this.hideProfile = this.$route.query.hideProfile === 'true'
    },
    mounted() {
    },
    components: {},
    watch: {},
    computed: {
      ...mapState('cv', ['cv', 'profiles', 'moduleData']),
      ...mapState('cvShare', ['allCommentData']),
      defaultText() {
        let langType = this.cv.basic_info && this.cv.basic_info.cv_type, type
        if (langType.includes('_cn') || langType.includes('_en')) {
          type = langType.split('_')[0]
        } else {
          type = this.cv.basic_info.cv_type
        }
        return editorPlaceHolder[type]
      },
    },
    methods: {
      ...mapMutations('cv', ['changeInfoTitle']),
      ...mapMutations('cvShare', ['setCurrentCommentInfo']),
      clearShareCommentInfo() {
        this.shareCommentInfo = {}
      },
      // 获取当前经历的的点评数据
      getInfoCommentData(type, id) {
        if (type === 'extras' || type === 'profile') {
          return this.allCommentData.find(item => item.type === type) || { comment_count: 0, comment: [], type }
        } else if (id) {
          return this.allCommentData.find(item => item.info_id === id) || { comment_count: 0, comment: [], type }
        }
      },
      // 点击添加点评
      addComment(moduleData, infoData) {
        if(this.isPlugin){
          return
        }
        this.$emit('addComment', moduleData, infoData)
      },
      // 添加模块经历
      async addInfo(item) {
        this.changeInfoTitle(item.title)
        if (item.id) {
          this.$router.push(`/cvs/${this.token}/${item.id}/${item.type}/add/edit`)
        } else if (item.type === 'extras') {
          this.$router.push({
            path: `/cvs/${this.token}/extras`,
            query: {add: 1}
          })
        } else {
          this.$router.push(`/cvs/${this.token}/${item.type}/add/edit`)
        }
      },
      // 点击预设文案
      defaultClick(item) {
        this.addInfo(item)
      },
      // 跳转到经历详情
      toInfoDetail(item, id) {
        if(this.isPlugin){
          return
        }
        this.shareCommentInfo = []
        if (this.pageType === 'editor') {
          this.changeInfoTitle(item.title)
          if (item.id) {
            this.$router.push(`/cvs/${this.token}/${item.id}/${item.type}/${id}/edit`)
          } else if (item.type === 'extras') {
            this.$router.push(`/cvs/${this.token}/extras`)
          } else {
            this.$router.push(`/cvs/${this.token}/${item.type}/${id}/edit`)
          }
        } else if (this.pageType === 'share') {
          if (item.type === 'extras') {
            this.setCurrentCommentInfo({
              type: item.type,
              info_id: null
            })
          } else {
            this.setCurrentCommentInfo({
              type: item.type,
              info_id: id
            })
          }
          let data = this.getInfoCommentData(item.type, id)
          if (data.comment_count) {
            this.$emit('changeCommentListState')
          } else if (this.authorityData.can_comment || this.authorityData.owner) {
            this.shareCommentInfo = item.type === 'extras' ? { type: 'extras' } : { id }
          }
        }
      },
      // 编辑基本信息
      toCvProfile() {
        if(this.isPlugin){
          return
        }
        if (this.pageType === 'editor') {
          this.$router.push(`/cvs/${this.token}/profiles`)
        } else {
          this.setCurrentCommentInfo({
            type: 'profile',
            info_id: null
          })
          let data = this.getInfoCommentData('profile', null)
          if (data.comment_count) {
            this.$emit('changeCommentListState')
          } else if (this.authorityData.can_comment || this.authorityData.owner) {
            this.profileCommentShow = true
            this.shareCommentInfo = { type: 'profile' }
          }
        }
      },
      // 删除校徽或者头像的confirm
      deleteConfirm(type) {
        this.$emit('deleteConfirm', type)
      },
      //
      changeUpload(type) {
        this.$emit('changeUpload', type)
      },
      //
      addAvatar() {
        this.$emit('addAvatar', this.pageType)
      }
    },
    filters: {
      countFilter(val) {
        return val > 99 ? '99+' : val
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/cv/mobile-cv';

  .cv-infos {
    width: 100vw;
    padding: 20px 24px 0;
    background-color: $color-light;
    border-radius: 3px;
    padding-bottom: 100px;
    box-sizing: border-box;
    .school-logo-wrapper {
      width: 100%;
      margin-top: 12px;
      margin-bottom: 16px;
      .school-logo {
        max-height: 45px;
        width: auto;
      }
    }
    .profile-wrapper {
      margin-bottom: 29px;
      padding-bottom: 29px;
      border-bottom: 1px solid #f9f9f9;
      .profile {
        flex: 1;
        color: $color-title;
        margin-right: 28px;
        font-size: $font-size-medium;

        .name {
          margin-bottom: 14px;
          font-size: 20px;
          font-weight: 500;

          span {
            font-size: 20px;
            font-weight: 500;
          }

          .iconfont {
            margin-left: 6px;
            font-size: 16px;
          }
        }

        .info {
          display: flex;
          flex-direction: column;
          line-height: 20px;
          color: $color-dark-gray;

          span {
            word-break: break-all;
          }
        }

        .no-profile {
          color: #bcbcbc;
        }
      }
      .avatar {
        position: relative;
        width: 72px;
        height: 86px;
        border-radius: 3px;
        font-size: 16px;
        border: 2px solid transparent;
        box-sizing: border-box;

        img {
          width: 68px;
          height: 82px;
          border: none;
          object-fit: contain;
        }
      }
      .school-logo-module {
        margin-top: 30px;

        .title {
          font-size: $font-size-large;
          color: $color-title;
          font-weight: 500;
          line-height: 20px;
          margin-right: 16px;
        }

        .logo-state {
          padding: 4px 6px;
          border-radius: 2px;
          border: 1px solid #d8d8d8;
          font-size: $font-size-small;
          color: $color-light-gray;
        }

        .iconfont {
          color: #9c9c9c;
        }

        .iconbianji {
          margin-right: 20px;
          font-size: 14px;
        }

        .iconshanchujianli {
          font-size: 18px;
        }
      }
    }
    .module-title {
      font-size: 20px;
      font-weight: 500;
      word-break: break-all;
    }
    .high-light-error {
      background-color: #f9f9f9;
    }

    &.isPlugin{
      *{
        color: #fff !important;
        border-bottom: 0;
      }
      .change-desc ::v-deep *{
        color: #fff !important;
      }
    }
  }
</style>
